import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.pad-start.js";
//
//
//
//
//
//
//
//
//
//
//
//
//

var DOTIMG_MAP = {
  'white': 'https://obj.pipi.cn/festatic/common/media/1636710678589-maohao-white.png',
  'red': 'https://obj.pipi.cn/festatic/common/media/1636710674857-maohao-red.png'
};
export default {
  name: 'count-time',
  props: {
    time: {
      type: Number,
      default: 0
    },
    prefixTxt: {
      type: String,
      default: ''
    },
    styleType: {
      oneOf: ['white', 'red'],
      default: 'red'
    },
    performanceId: {
      type: Number,
      default: 0
    },
    type: {
      oneOf: ['topList', 'projectList'],
      default: 'projectList'
    },
    isHasCountTime: {
      type: Boolean,
      default: true
    },
    newStyle: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      // 计时器
      timer: null,
      timeArr: null
    };
  },
  computed: {
    dotImg: function dotImg() {
      return DOTIMG_MAP[this.styleType];
    }
  },
  watch: {
    time: 'initTimer'
  },
  mounted: function mounted() {
    this.initTimer();
  },
  destroyed: function destroyed() {
    this.timeArr = null;
    clearInterval(this.timer);
  },
  methods: {
    initTimer: function initTimer() {
      clearInterval(this.timer);
      this.calculate();
      this.timer = setInterval(this.calculate, 1000);
    },
    calculate: function calculate() {
      var _this$time = this.time,
        time = _this$time === void 0 ? 0 : _this$time;
      var left = time - Date.now();
      if (left > 0) {
        var hour = Math.floor(left / (60 * 60 * 1000));
        left = left - hour * 60 * 60 * 1000;
        var minutes = Math.floor(left / (60 * 1000));
        left = left - minutes * 60 * 1000;
        var seconds = Math.floor(left / 1000);
        this.timeArr = [String(hour).padStart(2, '0'), String(minutes).padStart(2, '0'), String(seconds).padStart(2, '0')];
      } else {
        this.timeArr = null;
        clearInterval(this.timer);
        if (this.performanceId && this.isHasCountTime) {
          this.$emit('countDownEnd', {
            performanceId: this.performanceId,
            type: this.type
          });
        }
      }
    }
  }
};